export const WINDOW_WIDTH = Math.max(
  320,
  Math.min(window.innerWidth - 24, 600),
);
export const WINDOW_HEIGHT = Math.max(
  300,
  Math.min(window.innerHeight - 80, 500),
);
export type ContentType = "Texte" | "Tableau" | "Figure";

export const ICON_MAP: Record<ContentType, string> = {
  Texte: "file",
  Tableau: "crosstab",
  Figure: "image",
};
